import React from 'react'
import { Box, Flex } from 'grid-styled'
import ClickOut from 'react-click-out'
import { orderBy } from 'lodash'
import moment from 'moment'

import { ListContainer, ListItem, DropdownBox } from './styles'
import OrderRequestItem from './OrderRequestItem'
import Dropdown from './Dropdown'
import DropdownList from './DropdownList'
import { statusFilter } from './DropdownList/helpers'
import { orderStatus } from './data'

export default class OrdersRequestList extends React.Component {
  state = {
    isOpenStatus: false,
    selectedStatus: 'Todos',
    isOpenDate: false
  }

  toggleDropdownStatus = () => {
    this.setState({
      isOpenStatus: !this.state.isOpenStatus
    })
  }
  closeDropdownStatus = () => {
    this.setState({
      isOpenStatus: false
    })
  }
  toggleDropdownDate = () => {
    this.setState({
      isOpenDate: !this.state.isOpenDate
    })
  }

  sortDate = (orders, isOpenDate) => {
    const ordered = orderBy(orders, o => moment(o.date, 'DD/MM/YYYY').format('YYYYMMDD'))
    return isOpenDate ? ordered : ordered.reverse()
  }

  selectStatus = status => {
    this.setState({ selectedStatus: status })
    this.closeDropdownStatus()
  }

  render() {
    const { orders = [], accountId, type, history } = this.props
    const { isOpenStatus, selectedStatus, isOpenDate } = this.state
    return (
      <ListContainer>
        <ListItem>
          <Flex width={1} direction={['column', 'row']}>
            <Box width={[1 / 12]} />
            <Box width={[2 / 12]}>Nº do pedido</Box>
            <Box width={[2 / 12]}>
              <Dropdown
                isOpen={isOpenDate}
                categoryLabel="DATA DO PEDIDO"
                dropdownLabel={isOpenDate ? 'Mais antigos' : 'Mais recentes'}
                onClick={this.toggleDropdownDate}
              />
            </Box>
            <DropdownBox width={[2 / 12]}>
              <Dropdown
                isOpen={isOpenStatus}
                categoryLabel="STATUS"
                dropdownLabel={selectedStatus}
                onClick={this.toggleDropdownStatus}
              />
              {this.state.isOpenStatus && (
                <ClickOut callback={this.closeDropdownStatus}>
                  <DropdownList
                    options={orderStatus}
                    isOpen={isOpenStatus}
                    onClose={this.toggleDropdown}
                    onSelect={this.selectStatus}
                  />
                </ClickOut>
              )}
            </DropdownBox>
            <Box width={[5 / 12]} />
          </Flex>
        </ListItem>
        {statusFilter(selectedStatus, this.sortDate(orders, isOpenDate)).map((order, index) => (
          <OrderRequestItem
            order={order}
            key={index}
            accountId={accountId}
            type={type}
            history={history}
          />
        ))}
      </ListContainer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/OrdersRequestList/index.js